import React from 'react'
import JobPortal from './JobPortal'
import Hero from '../components/Hero'

const CurrentVacancies = () => {
  return (
   <>
   <Hero
      title="Join Our Team - Current Openings"
      description="We are looking for talented individuals to fill exciting positions across various departments. Browse our open roles below"
      buttonText=""
      customClass="contractorBanner"
      imageSrc="/images/hero.png"
      squareColor="Contractorsquare-bg-color"
    />
   <JobPortal/>
   </>
  )
}

export default CurrentVacancies